<!-- eslint-disable max-len -->
<!-- eslint-disable vue/valid-v-slot -->
<!-- eslint-disable vue/no-mutating-props -->
<template>
  <v-row>
    <v-col>
      <div v-if="betsLoading" style="height: 60vh;">
        <h2 style="display: flex;justify-content: center;" class="mb-1">Please be patient, results may take several seconds to appear</h2>
        <v-progress-linear v-model="value" :buffer-value="bufferValue" color="pink"></v-progress-linear>
        <v-skeleton-loader type="table-heading"></v-skeleton-loader>
        <v-skeleton-loader type="table-tbody"></v-skeleton-loader>
      </div>
<!-- FROM HERE VUETIFY TABLE -->
      <v-data-table
        dense
        style="font-weight:500 !important;"
        v-if="!isBetBack && !betsLoading"
        fixed-header
        height="60vh"
        ref="table"
        item-key="key"
        id="tableid"
        :headers="headers"
        :items="mutateData(dataTable[currentPage])"
        :items-per-page="100"
        :hide-default-footer="true"
        hide-default-header
      >
        <!-- <template v-slot:header="{ props: { headers } }">
          <thead>
            <tr>
              <th
                  v-for="item in headers"
                  :key="item.value"
                  class="column"
                  @click="item.sortable ? changeSort(item.value) : ''"
              >
                {{ item.text }}
                <v-icon v-if="item.sortable" small>mdi-arrow-up</v-icon>
              </th>
            </tr>
          </thead>
        </template> -->
        <template v-slot:header="{ props: { headers } }">
          <thead>
            <tr>
              <th
                  v-for="item in headers"
                  :key="item.value"
                  class="column"
              >
                <span :style="filtersApplied[item.value] ? 'color: #000;' : ''">{{ item.text }}</span>
                <v-icon v-if="item.sortable" @click="changeSort(item.value, 0)" small :disabled="currentPage === 1 ? (typeof dataTable[currentPage] === 'undefined' || typeof dataTable[currentPage+1] === 'undefined' || typeof dataTable[currentPage+2] === 'undefined') : (typeof dataTable[currentPage-1] === 'undefined' || typeof dataTable[currentPage] === 'undefined' || typeof dataTable[currentPage+1] === 'undefined')">mdi-arrow-up</v-icon>
                <v-icon v-if="item.sortable" @click="changeSort(item.value, 1)" small :disabled="currentPage === 1 ? (typeof dataTable[currentPage] === 'undefined' || typeof dataTable[currentPage+1] === 'undefined' || typeof dataTable[currentPage+2] === 'undefined') : (typeof dataTable[currentPage-1] === 'undefined' || typeof dataTable[currentPage] === 'undefined' || typeof dataTable[currentPage+1] === 'undefined')">mdi-arrow-down</v-icon>
                <v-menu offset-y :close-on-content-click="false">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-if="item.filterable" small v-bind="attrs" v-on="on" :color="filtersApplied[item.value] ? '#2196f3' : ''">mdi-filter</v-icon>
                  </template>
                  <v-list>
                    <v-list-item v-if="item.value === 'medium'">
                      <v-list-item-content>
                        <v-list-item-title>Select <strong>{{ item.text }}</strong> to filter by:</v-list-item-title>
                        <v-list-item-subtitle>
                          <v-radio-group v-model="medium" @change="filterBy()" dense hide-details class="pl-2">
                            <v-radio
                              v-for="medium in getMediums"
                              :key="medium.value"
                              :label="medium.name"
                              :value="medium.value"
                            ></v-radio>
                            <v-radio
                              label="None"
                              value="none"
                            ></v-radio>
                          </v-radio-group>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item v-else-if="item.value === 'infoType'">
                      <v-list-item-content>
                        <v-list-item-title>Select <strong>{{ item.text }}</strong> to filter by:</v-list-item-title>
                        <v-list-item-subtitle>
                          <v-radio-group v-model="infoType" @change="filterBy()" dense hide-details class="pl-2">
                            <v-radio
                              v-for="type in getInfoTypes"
                              :key="type.name"
                              :label="type.name"
                              :value="type.name"
                            ></v-radio>
                            <v-radio
                              label="None"
                              value="none"
                            ></v-radio>
                          </v-radio-group>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item v-else-if="item.value === 'type'">
                      <v-list-item-content>
                        <v-list-item-title>Select <strong>{{ item.text }}</strong> to filter by:</v-list-item-title>
                        <v-list-item-subtitle>
                          <v-radio-group v-model="betType" @change="filterBy()" dense hide-details class="pl-2">
                            <v-radio
                              v-for="type in getBetTypes"
                              :key="type.value"
                              :label="type.name"
                              :value="type.value"
                            ></v-radio>
                            <v-radio
                              label="None"
                              value="none"
                            ></v-radio>
                          </v-radio-group>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item v-else-if="item.value === 'source'">
                      <v-list-item-content>
                        <v-list-item-title>Select <strong>{{ item.text }}</strong> to filter by:</v-list-item-title>
                        <v-list-item-subtitle>
                          <v-radio-group v-model="source" @change="filterBy()" row dense hide-details class="pl-2">
                            <v-radio
                              v-for="(value, key) in bookiescolumn"
                              :key="key"
                              :value="value.bookie"
                            >
                              <template v-slot:label>
                                <img :src="`https://betmakers.com/img/circle_logos/${value.bookie}.png`" style="width: 25px; height: 25px; margin-top: 5px" />
                              </template>
                            </v-radio>
                            <v-radio
                              label="None"
                              value="none"
                            ></v-radio>
                          </v-radio-group>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item v-else-if="item.value === 'time'">
                      <v-list-item-content>
                        <v-list-item-title>Enter <strong>{{ item.text }}</strong> to filter by:</v-list-item-title>
                        <v-list-item-subtitle style="width: 160px;">
                          <v-menu ref="menu" v-model="menu" transition="scale-transition" offset-y min-width="0%" :nudge-right="40">
                            <template v-slot:activator="{ on }">
                              <v-text-field class="formattedDate" v-model="betDate" small prepend-icon="mdi-calendar" readonly v-on="on" style="font-size:14px; width: 140px; display: inline-flex;" hide-details=""></v-text-field>
                            </template>
                            <v-date-picker v-model="betDate" no-title scrollable actions>
                              <v-spacer></v-spacer>
                              <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                              <v-btn text color="primary" @click="$refs.menu.save(betDate)">OK</v-btn>
                            </v-date-picker>
                          </v-menu>
                          <vue-timepicker manual-input hide-dropdown v-model="betTime" style="margin-top: -10px; margin-left: 30px;"></vue-timepicker>
                          <v-btn fab x-small outlined color="success" @click="filterBy()" style="margin-left: 20px; margin-top: -10px;">
                            <v-icon>mdi-check</v-icon>
                          </v-btn>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item v-else-if="item.value === 'id'">
                      <v-list-item-title>Enter <strong>{{ item.text }}</strong> to filter by:</v-list-item-title>
                      <v-text-field :label="item.text" v-model="betId" @keydown.enter="filterBy()"></v-text-field>
                    </v-list-item>
                    <v-list-item v-else-if="item.value === 'userId'">
                      <v-list-item-title>Enter <strong>{{ item.text }}</strong> to filter by:</v-list-item-title>
                      <v-text-field :label="item.text" v-model="clientRef" @keydown.enter="filterBy()"></v-text-field>
                    </v-list-item>
                    <v-list-item v-else-if="item.value === 'raceNumber'">
                      <v-list-item-title>Enter <strong>{{ item.text }}</strong> to filter by:</v-list-item-title>
                      <v-text-field :label="item.text" v-model="raceNumber" @keydown.enter="filterBy()"></v-text-field>
                    </v-list-item>
                    <v-list-item v-else-if="item.value === 'runnerNumber'">
                      <v-list-item-title>Enter <strong>{{ item.text }}</strong> to filter by:</v-list-item-title>
                      <v-text-field :label="item.text" v-model="runnerNumber" @keydown.enter="filterBy()"></v-text-field>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </th>
            </tr>
          </thead>
        </template>
        <template v-slot:item.source="{ item }">
          <v-tooltip transition="none" bottom>
            <template v-slot:activator="{ on, attrs }">
              <img v-bind="attrs" v-on="on"
              :src="`https://betmakers.com/img/circle_logos/${item.source}.png`" style="width: 25px; height: 25px; margin-top: 5px" />
            </template>
            <span>{{BOOKMAKER_NAMES_LOOKUP[item.source]}} | {{item.source}}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.meetingType="{ item }">
          <img :src="image[item.meetingType]" style="max-width:20px;" />
        </template>
        <template v-slot:item.net_result="{ item }">
          <span>{{item.net_result || `$0.00`}}</span>
        </template>
        <template v-slot:item.payout="{ item }">
          <span>{{item.payout || `$0.00`}}</span>
        </template>
        <template v-slot:item.bonus="{ item }">
          <span>{{capitalizeFirstLetter(item.bonus) || `False`}}</span>
        </template>
        <template v-slot:item.type="{ item }">
          <span v-if="item.legs >= 1 && multiRaceExotic(item.type)">
            <v-tooltip transition="none" open-delay="100" color="transparent" bottom>
              <template v-slot:activator="{ on, attrs }">
                <span @mouseover="multiHover(item)" v-on="on" v-bind="attrs" style="text-decoration: underline dotted; font-weight: bold; cursor:pointer;">
                  {{ item.type }}
                </span>
              </template>
              <span>
                <v-card style="z-index: 999">
                  <v-simple-table dense style="box-shadow: 0 0 7px 3px rgb(155,155,155)">
                    <thead>
                      <tr>
                        <th>Leg</th>
                        <th>Race</th>
                        <th>Venue</th>
                        <th>Type</th>
                        <th>Runner</th>
                        <th>Name</th>
                        <th>Amount</th>
                        <th>Bonus Bet</th>
                        <th>Price</th>
                        <th>Payout</th>
                        <th>Net Result</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="d in childrenBets(item)" :key="d.key">
                        <td>{{ d.leg }}</td>
                        <td>{{ d.raceNumber }}</td>
                        <td>{{ d.track }}</td>
                        <td>{{ RACE_TYPE[d.meetingType] }}</td>
                        <td>{{ d.runnerNumber }}</td>
                        <td>{{ d.runnerName }}</td>
                        <td>${{ d.amount.toFixed(2) }}</td>
                        <td v-if="d.bonus">{{ d.bonus }}</td>
                        <td v-else>false</td>
                        <td>${{ d.price.toFixed(2) }}</td>
                        <td>${{ d.payout || `0.00`}}</td>
                        <td v-if="d.netResult">${{ parseFloat(d.netResult).toFixed(2) || `0.00`}}</td>
                        <td v-else>$0.00</td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                  <v-skeleton-loader v-if="!childrenBets(item)" type="article, actions" width="100%"></v-skeleton-loader>
                </v-card>
              </span>
            </v-tooltip>
          </span>
          <span v-else>
            {{ item.type }}
          </span>
        </template>
      </v-data-table>
<!-- UNTIL HERE VUETIFY TABLE -->
      <v-divider v-if="!isBetBack"></v-divider>
      <br v-if="!isBetBack">
      <v-btn class="mr-2" dark color="blue" @click="clearAllFilters">Clear Filters</v-btn>
      <v-btn class="mr-2" dark color="blue" @click="clearSortFields">Clear Sort</v-btn>
      <v-pagination
        v-if="!isBetBack && !isMeeting && !isRace && !isAll"
        v-model="currentPage"
        :length="currentPage + 2"
        circle
        next-icon="mdi-menu-right"
        prev-icon="mdi-menu-left"
        @input="handlePageChange"
        style="display: inline;"
      ></v-pagination>
      <v-pagination
        v-if="!isBetBack && isMeeting"
        v-model="currentPage"
        :length="currentPage + 2"
        circle
        next-icon="mdi-menu-right"
        prev-icon="mdi-menu-left"
        @input="handlePageMeetingChange"
        style="display: inline;"
      ></v-pagination>
      <v-pagination
        v-if="!isBetBack && isRace"
        v-model="currentPage"
        :length="currentPage + 2"
        circle
        next-icon="mdi-menu-right"
        prev-icon="mdi-menu-left"
        @input="handlePageRaceChange"
        style="display: inline;"
      ></v-pagination>
      <v-pagination
        v-if="!isBetBack && isAll"
        v-model="currentPage"
        :length="currentPage + 2"
        circle
        next-icon="mdi-menu-right"
        prev-icon="mdi-menu-left"
        @input="handlePageAllChange"
        style="display: inline;"
      ></v-pagination>
      <v-progress-circular
        :width="3"
        color="red"
        indeterminate
        :style="currentPage > 1 ? 'margin-left: -55%; margin-top: 5px;' : ''"
        v-if="currentPage > 1 ? typeof dataTable[currentPage - 1] === 'undefined' : false"
      ></v-progress-circular>
      <v-progress-circular
        :width="3"
        color="red"
        indeterminate
        :style="currentPage === 1 ? 'margin-left: -48%; margin-top: 8px;' : 'margin-left: -47%; margin-top: -10px;'"
        v-if="currentPage === 1 && typeof dataTable[currentPage] !== 'undefined' && dataTable[currentPage].length < 100 ? false : typeof dataTable[currentPage + 1] === 'undefined'"
      ></v-progress-circular>
    </v-col>
  </v-row>
</template>
<script>
/* eslint-disable prefer-template */
import { mapActions, mapGetters, mapState } from 'vuex'
import numeral from 'numeral'
import { BET_TYPE, BOOKMAKER_NAMES_LOOKUP, RACE_TYPE } from '../../common/constants'
import { loaders } from '@/store'
import { constants } from '../RaceTable'
import { format } from 'date-fns'
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'

export default {
  name: 'RaceTable',
  data () {
    return {
      RACE_TYPE,
      value: 0,
      bufferValue: 100,
      interval: 0,
      currentPage: this.getCurrentPage || 1,
      BOOKMAKER_NAMES_LOOKUP,
      medium: 'none',
      infoType: 'none',
      betType: 'none',
      source: 'none',
      betId: '',
      clientRef: '',
      raceNumber: '',
      runnerNumber: '',
      menu: false,
      betDate: format(new Date(), 'yyyy-MM-dd'),
      betTime: '',
      sortBy: '',
      sortType: ''
    }
  },
  props: {
    isBetBack: {
      type: Boolean,
      default: false
    },
    isMeeting: {
      type: Boolean,
      default: false
    },
    isRace: {
      type: Boolean,
      default: false
    },
    isAll: {
      type: Boolean,
      default: false
    },
    headers: {
      type: Array,
      required: true
    },
    dataTable: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VueTimepicker
  },
  watch: {
    value (val) {
      if (val < 100) return
      this.value = 0
      this.startBuffer()
    },
    restartPagination () {
      if (this.restartPagination) {
        this.currentPage = 1
      }
    }
  },
  mounted () {
    this.startBuffer()
    this.hideShowLoader()
  },
  beforeDestroy () {
    clearInterval(this.interval)
  },
  computed: {
    ...mapState(['totalPages', 'page', 'loading', 'childBets', 'restartPagination', 'bookiescolumn']),
    ...mapGetters(['getPage', 'getTotalPages', 'getFiltersApplied']),
    getCurrentPage () {
      return this.getPage || 1
    },
    betsLoading () {
      return this.loading[loaders.BETS]
    },
    totalPages () {
      return Math.ceil(this.getTotalPages / 100) || 1
    },
    getMediums () {
      return constants.mediums
    },
    getInfoTypes () {
      return constants.infoTypes
    },
    getBetTypes () {
      return constants.betTypes
    },
    image () {
      return {
        HARNESS: require('@/assets/RaceType_Harness-BLACK.svg'),
        THOROUGHBRED: require('@/assets/RaceType_Gallops-BLACK.svg'),
        GREYHOUND: require('@/assets/RaceType_Greyhounds-BLACK.svg')
      }
    },
    filtersApplied () {
      return this.getFiltersApplied
    }
  },
  methods: {
    ...mapActions(['fetchBets', 'fetchBetBacks', 'fetchBetSummary', 'fetchBetsAll', 'fetchBetsMeeting', 'fetchBetsRace', 'fetchChildBets', 'setExportFilters', 'setSelectedCountry', 'setSelectedState', 'clearMeetingType', 'setSelectedRunnersArray', 'setSelectedBetBack', 'clearFiltersBy', 'clearExportFilters']),
    clearSortFields () {
      let formattedTime = ''
      if (this.betTime !== '') {
        formattedTime = this.betDate + ' ' + this.betTime + ':00'
      }

      this.fetchBetSummary({
        medium: this.medium,
        infoType: this.infoType,
        betType: this.betType,
        source: this.source,
        betId: this.betId,
        clientRef: this.clientRef,
        raceNumber: this.raceNumber,
        runnerNumber: this.runnerNumber,
        time: formattedTime,
        country: 'intoState',
        meetingType: 'intoState',
        state: 'intoState',
        clearFilteredBets: true,
        // meetingId: 'intoState',
        runnersArray: 'intoState',
        betBack: 'intoState',
        sortFields: {},
        overrides: { pagination: { page: this.currentPage, limit: 100 }, filtered: true }
      })
    },
    clearAllFilters () {
      this.medium = 'none'
      this.infoType = 'none'
      this.betType = 'none'
      this.source = 'none'
      this.betId = ''
      this.clientRef = ''
      this.raceNumber = ''
      this.runnerNumber = ''
      this.betTime = ''

      let formattedTime = ''
      if (this.betTime !== '') {
        formattedTime = this.betDate + ' ' + this.betTime + ':00'
      }

      this.clearFiltersBy(true)
      this.clearExportFilters()

      this.fetchBetSummary({
        medium: this.medium,
        infoType: this.infoType,
        betType: this.betType,
        source: this.source,
        betId: this.betId,
        clientRef: this.clientRef,
        raceNumber: this.raceNumber,
        runnerNumber: this.runnerNumber,
        time: formattedTime,
        country: 'none',
        meetingType: 'none',
        state: 'none',
        clearFilteredBets: true,
        // meetingId: 'intoState',
        runnersArray: '',
        betBack: 'none',
        sortFields: { sortBy: 'intoState', sortType: 0 },
        overrides: { pagination: { page: this.currentPage, limit: 100 }, filtered: true }
      })
    },
    changeSort (sortBy, sortType) {
      this.sortBy = sortBy
      this.sortType = sortType
      this.currentPage = 1

      let formattedTime = ''
      if (this.betTime !== '') {
        formattedTime = this.betDate + ' ' + this.betTime + ':00'
      }

      this.fetchBetSummary({
        medium: this.medium,
        infoType: this.infoType,
        betType: this.betType,
        source: this.source,
        betId: this.betId,
        clientRef: this.clientRef,
        raceNumber: this.raceNumber,
        runnerNumber: this.runnerNumber,
        time: formattedTime,
        country: 'intoState',
        meetingType: 'intoState',
        state: 'intoState',
        clearFilteredBets: true,
        // meetingId: 'intoState',
        runnersArray: 'intoState',
        betBack: 'intoState',
        sortFields: { sortBy: sortBy, sortType: sortType },
        overrides: { pagination: { page: this.currentPage, limit: 100 }, filtered: true }
      })
    },
    filterBy () {
      this.currentPage = 1

      let formattedTime = ''
      if (this.betTime !== '') {
        formattedTime = this.betDate + ' ' + this.betTime + ':00'
      }
      this.setExportFilters({
        medium: this.medium,
        infoType: this.infoType,
        betType: this.betType,
        source: this.source,
        betId: this.betId,
        clientRef: this.clientRef,
        raceNumber: this.raceNumber,
        runnerNumber: this.runnerNumber,
        time: formattedTime,
        country: 'intoState',
        meetingType: 'intoState',
        state: 'intoState',
        clearFilteredBets: true,
        runnersArray: 'intoState',
        betBack: 'intoState'
      })
      this.fetchBetSummary({
        medium: this.medium,
        infoType: this.infoType,
        betType: this.betType,
        source: this.source,
        betId: this.betId,
        clientRef: this.clientRef,
        raceNumber: this.raceNumber,
        runnerNumber: this.runnerNumber,
        time: formattedTime,
        country: 'intoState',
        meetingType: 'intoState',
        state: 'intoState',
        clearFilteredBets: true,
        // meetingId: 'intoState',
        runnersArray: 'intoState',
        betBack: 'intoState',
        sortFields: { sortBy: 'intoState', sortType: 0 },
        overrides: { pagination: { page: this.currentPage, limit: 100 }, filtered: true }
      })
    },
    hideShowLoader () {
      if (this.currentPage === 1) {
        const element = document.getElementsByClassName('mdi-menu-right')[0].parentElement
        if (typeof this.dataTable[this.currentPage + 1] === 'undefined') {
          element.classList.add('v-pagination__navigation--disabled')
        } else {
          element.classList.remove('v-pagination__navigation--disabled')
        }
      } else {
        if (Object.keys(this.dataTable).length > 0) {
          if (Object.keys(this.dataTable[this.currentPage]).length === 100) {
            const elementLeft = document.getElementsByClassName('mdi-menu-left')[0].parentElement
            const elementRight = document.getElementsByClassName('mdi-menu-right')[0].parentElement
            if (typeof this.dataTable[this.currentPage - 1] === 'undefined') {
              elementLeft.classList.add('v-pagination__navigation--disabled')
            } else {
              elementLeft.classList.remove('v-pagination__navigation--disabled')
            }

            if (typeof this.dataTable[this.currentPage + 1] === 'undefined') {
              elementRight.classList.add('v-pagination__navigation--disabled')
            } else {
              elementRight.classList.remove('v-pagination__navigation--disabled')
            }
          }
        }
      }
    },
    childrenBets (bet) {
      const key = `${bet.id}${bet.source}`
      return this?.childBets[key]
    },
    multiHover (bet) {
      const key = `${bet.id}${bet.source}`
      if (bet && Object.keys(this.childBets).includes(key)) {
        return
      }
      this.fetchChildBets(bet)
    },
    capitalizeFirstLetter (string) {
      let newStr
      if (string) {
        const stringCnv = string.toString()
        newStr = stringCnv[0].toUpperCase() + stringCnv.slice(1)
      }
      return newStr
    },
    startBuffer () {
      clearInterval(this.interval)
      this.interval = setInterval(() => {
        this.value += Math.random() * (15 - 5) + 5
      }, 750)
    },
    handlePageChangeBetBack (value) {
      this.currentPage = value
      this.fetchBetBacks({ pagination: { page: value, limit: 100 }, filtered: true })
    },
    handlePageChange (value) {
      const rows = document.querySelectorAll('#tableid tr')
      rows[0].scrollIntoView()
      this.currentPage = value

      let formattedTime = ''
      if (this.betTime !== '') {
        formattedTime = this.betDate + ' ' + this.betTime + ':00'
      }

      this.fetchBetSummary({
        medium: this.medium,
        infoType: this.infoType,
        betType: this.betType,
        source: this.source,
        betId: this.betId,
        clientRef: this.clientRef,
        raceNumber: this.raceNumber,
        runnerNumber: this.runnerNumber,
        time: formattedTime,
        country: 'intoState',
        meetingType: 'intoState',
        state: 'intoState',
        clearFilteredBets: false,
        // meetingId: 'intoState',
        runnersArray: 'intoState',
        betBack: 'intoState',
        sortFields: { sortBy: 'intoState', sortType: 0 },
        overrides: { pagination: { page: this.currentPage, limit: 100 }, filtered: true }
      })
      this.hideShowLoader()
    },
    handlePageMeetingChange (value) {
      const rows = document.querySelectorAll('#tableid tr')
      rows[0].scrollIntoView()
      this.currentPage = value
      this.fetchBetsMeeting({ overrides: { pagination: { page: value, limit: 100 }, filtered: true }, sortFields: { sortBy: this.sortBy, sortType: this.sortType } })
    },
    handlePageRaceChange (value) {
      const rows = document.querySelectorAll('#tableid tr')
      rows[0].scrollIntoView()
      this.currentPage = value
      this.fetchBetsRace({ overrides: { pagination: { page: value, limit: 100 }, filtered: true }, sortFields: { sortBy: this.sortBy, sortType: this.sortType } })
    },
    handlePageAllChange (value) {
      const rows = document.querySelectorAll('#tableid tr')
      rows[0].scrollIntoView()
      this.currentPage = value

      let formattedTime = ''
      if (this.betTime !== '') {
        formattedTime = this.betDate + ' ' + this.betTime + ':00'
      }

      this.fetchBetSummary({
        medium: this.medium,
        infoType: this.infoType,
        betType: this.betType,
        source: this.source,
        betId: this.betId,
        clientRef: this.clientRef,
        raceNumber: this.raceNumber,
        runnerNumber: this.runnerNumber,
        time: formattedTime,
        country: 'intoState',
        meetingType: 'intoState',
        state: 'intoState',
        clearFilteredBets: false,
        // meetingId: 'intoState',
        runnersArray: 'intoState',
        betBack: 'intoState',
        sortFields: { sortBy: 'intoState', sortType: 0 },
        overrides: { pagination: { page: this.currentPage, limit: 100 }, filtered: true }
      })
    },
    mutateData (d) {
      if (Object.keys(this.dataTable).length > 0) {
        const element = document.getElementsByClassName('mdi-menu-right')[0].parentElement
        if (typeof this.dataTable[this.currentPage] !== 'undefined' && Object.keys(this.dataTable[this.currentPage]).length < 100) {
          element.classList.add('v-pagination__navigation--disabled')
        } else {
          element.classList.remove('v-pagination__navigation--disabled')
        }
      }
      const res = d?.map((b) => {
        const a = { ...b }
        if (a.type) {
          a.type = BET_TYPE[a.type]
        }
        if (a.price) {
          a.price = numeral(a.price).format('$0,0.00')
        }
        if (a.amount) {
          a.amount = numeral(a.amount).format('$0,0.00')
        }
        if (a.payout) {
          a.payout = numeral(a.payout).format('$0,0.00')
        }
        if (a.net_result) {
          a.net_result = numeral(a.net_result).format('$0,0.00')
        }
        if (a.children && a.type === 'multi') {
          a.canExpand = true
        }
        if (a.children && a.type !== 'multi') {
          const childArr = a.children
          const runnerArr = []
          childArr.forEach((f) => {
            runnerArr.push(f.runnerNumber)
          })
          a.runnerNumber = runnerArr.join(', ')
        }
        if (a.exoticsSelections !== 'NULL') {
          a.runnerNumber = a.exoticsSelections
        }
        return a
      })
      this.hideShowLoader()
      return res
    },
    multiRaceExotic (type) {
      switch (type) {
        case 'Multi':
          return true
        case 'Double':
          return true
        case 'Quadrella':
          return true
        default:
          return false
      }
    }
  }
}
</script>
<style scoped>
  .v-data-table {
    white-space:nowrap;
  }
  .v-tooltip__content {
    opacity: 1 !important;
  }
  /deep/ .v-pagination__item {
    display: none;
  }
  /deep/ .v-pagination__item--active {
    display: initial;
  }
  /deep/ .v-pagination__more {
    display: none;
  }
  /deep/ .v-pagination__navigation--disabled {
    display: none;
  }
</style>
